import { render } from "./Sondaggi.vue?vue&type=template&id=1a9de4ae&scoped=true&ts=true"
import script from "./Sondaggi.vue?vue&type=script&lang=ts"
export * from "./Sondaggi.vue?vue&type=script&lang=ts"

import "./Sondaggi.vue?vue&type=style&index=0&id=1a9de4ae&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9de4ae"]])

export default __exports__